<script lang="ts">
	const { orientation = 'landscape' }: { orientation?: 'portrait' | 'landscape' } = $props();
</script>

{#if orientation == 'portrait'}
	<svg
		width="100%"
		height="100%"
		id="Lag_1"
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		viewBox="0 0 48 200"
	>
		<defs>
			<style>
				.st0 {
					fill: #010101;
				}
			</style>
		</defs>
		<polygon
			class="st0"
			points="29.2 44.7 21.1 42.4 21.1 42.3 29.2 40.1 29.2 37.5 18.8 40.6 18.8 44 29.2 47.1 29.2 44.7"
		/>
		<path
			class="st0"
			d="M28.9,49c.9,0,1.6.7,1.6,1.7s-.7,1.7-1.6,1.7-1.6-.7-1.6-1.7.7-1.7,1.6-1.7M21.9,49.5h2.3l-.4-2.1h2.2l.8,4.5h-4.7c-1,0-1.4.4-1.4,1s.5,1.1,1.2,1.3l1.1.3-.5,2-.7-.2c-2.3-.7-3.1-2.1-3.1-3.6s1-3.2,3.2-3.2"
		/>
		<path
			class="st0"
			d="M22.9,69.2c1.4,0,1.9-.7,1.9-1.7s-.7-2.1-1-2.5c-2.2,0-3,.9-3,2.2s.7,1.9,2.2,1.9M22.4,62.7h7.3l.3,2.4h-5.3v.2c1.5.7,2.2,1.7,2.2,3.1s-1.1,3.3-3.9,3.3-4.4-1.7-4.4-3.8.8-2.4,2.3-2.9v-.2l-2.2-.4v-2.4l3.6.7h0Z"
		/>
		<path
			class="st0"
			d="M23.3,79.2c1.1-.2,1.6-.9,1.6-2.1s-.6-1.9-1.6-2.1c0,0,0,4.2,0,4.2ZM22.7,72.5c2.2,0,4.2,1.3,4.2,4.6s-1.6,4.3-4.7,4.5v-6.6c-1.2.2-1.6,1.2-1.6,2.4s.3,1.8.9,2.8l-1.7,1c-.8-1.2-1.2-2.5-1.2-3.9,0-3.4,2-4.7,4.1-4.7"
		/>
		<polygon
			class="st0"
			points="26.7 81.5 26.7 84.2 20.9 86.2 20.9 86.3 26.7 88.5 26.7 90.8 18.8 87.6 18.8 84.8 26.7 81.5"
		/>
		<path
			class="st0"
			d="M23.3,99.6c1.2,0,1.9-.2,1.9-.9s-.7-1.2-1.9-1.3c0,0,0,2.2,0,2.2ZM21.7,95.3h1.3c-.2-.4-.3-.7-.5-.9-.3-.5-.7-.8-1.3-.8s-.9.3-.9.6c0,.6.7,1,1.4,1M20.2,96v-.2c-1.1-.3-1.6-1.4-1.6-2.3s.8-2.1,2.2-2.1c2.1,0,2.9,1.8,2.6,3.7h0c1.2.1,1.6-.2,1.6-.9s-.3-1.4-1-2.2l1.4-.9c.8.9,1.4,2.2,1.4,3.3s-.3,1.6-.8,2c.5.5.8,1.2.8,2.2,0,2.1-1.5,3-4.6,2.9v-4.2c-1.4.1-2,.7-2,1.6s.2,1.1.8,1.9l-1.3.9c-.8-1-1.2-2-1.2-2.9s.5-2.2,1.7-2.8"
		/>
		<path
			class="st0"
			d="M23.8,108.5c1,0,1.5-.7,1.5-1.6s-.5-1.7-1.5-1.7-1.5.7-1.5,1.6.5,1.6,1.5,1.6M16.4,107.2c0,2.1.4,2.3.8,2.3s.5-.4.5-1.6v-2.1c0-.7,0-1.3-.5-1.3s-.8,1.2-.8,2.7M16.6,102.5c.8,0,1.4.3,1.5,1.8h.2c0-1.2.5-1.8,1.4-1.8s1.3.5,1.5,1.8h.2c.5-.8,1.4-1.3,2.5-1.3,1.8,0,3.1,1.3,3.1,4s-.1,1.4-.4,1.9c.4-.2.8-.2,1.1-.2.9,0,1.3.7,1.3,2.2s0,.8,0,1.3h-2c0-.5,0-1,0-1.3,0-.7,0-1.1-.5-1.1-.7,0-1.1,1-2.7,1s-3.2-1.3-3.2-3.8,0-.4,0-.7c.1-1.8,0-2.1-.3-2.1-.4,0-.4.6-.4,2.2v1.6c0,2.8-.4,3.9-2.2,3.9s-2.8-.9-2.8-5.1.3-4.2,1.7-4.2"
		/>
		<path
			class="st0"
			d="M23.3,118.7c1.1-.2,1.6-.9,1.6-2.1s-.6-1.9-1.6-2.1v4.2ZM22.7,112c2.2,0,4.2,1.3,4.2,4.6s-1.6,4.3-4.7,4.5v-6.6c-1.2.2-1.6,1.2-1.6,2.4s.3,1.8.9,2.8l-1.7,1c-.8-1.2-1.2-2.5-1.2-3.9,0-3.4,2-4.7,4.1-4.7"
		/>
		<path
			class="st0"
			d="M24.6,123.8v-2.2h1.8l.5,4.4h-3.8v.2c1.9.2,3.2,1.1,3.8,3.9l-2.4.7c-.7-3.5-1.8-4.6-3.1-4.6h-2.6v-2.4h5.8Z"
		/>
		<path
			class="st0"
			d="M23.9,140.1l3.3-.8v-.9l-3.3-.8v2.6ZM29.2,136.7v4.1l-10.4,3.1v-2.6l2.9-.8v-3.6l-2.9-.7v-2.4l10.4,2.8h0Z"
		/>
		<path
			class="st0"
			d="M22.2,150h.8c-.1-.4-.4-1.3-.6-1.8-.3-.9-.6-1.4-1.1-1.4s-.7.4-.7,1.1c0,1,.4,2.1,1.6,2.1M20.8,144.4c2.5,0,3.5,3.4,2.5,5.4h0c1.1.1,1.5-.3,1.5-1.3s-.5-2.5-1.6-3.5l1.6-1.1c1.3,1.3,2,3.1,2,4.8s-.9,3.6-3,3.6h-2.2c-.6,0-.8.2-.8.8v.9h-2.2v-.7c0-1.7.4-2.8,2.3-2.9v-.2c-1.6-.2-2.5-1.6-2.5-3.3s.7-2.6,2.2-2.6"
		/>
		<path
			class="st0"
			d="M24.7,156.1v-2.2h1.8l.5,4.4h-3.8v.2c1.9.2,3.2,1.1,3.8,3.9l-2.4.7c-.7-3.5-1.8-4.6-3.1-4.6h-2.6v-2.4h5.8Z"
		/>
		<path
			class="st0"
			d="M29.8,164.1l.3,2.4h-5.8c1.8.4,2.7,1.4,2.7,3s-1.5,2.6-3.2,2.6h-5v-2.4h4.7c.8,0,1.2-.3,1.2-1.2s-.4-2-3-2h-3v-2.4h10.9Z"
		/>
		<path
			class="st0"
			d="M20.2,189.3l1.8,1.1c-.9,1.1-1.3,2.4-1.3,3.7s.2,1.6.6,1.6c1.2,0,0-5.8,3.1-5.8s2.5,1.2,2.5,3.9-.4,2.9-1.1,4.2l-2-.8c.7-1.1,1-2.3,1-3.5s-.2-1.4-.5-1.4c-1.2,0,.2,5.8-3,5.8s-2.7-1.8-2.7-4.1.5-3.4,1.6-4.7"
		/>
		<path
			class="st0"
			d="M26.4,189.2l-.7-2.1c-3-.3-5.3-2.9-5.3-5.9s2.3-5.6,5.3-5.9l.7-2h0c-4.4,0-8,3.6-8,8s3.6,8,8,8h0Z"
		/>
		<path
			class="st0"
			d="M47.4,1.3l-6,2c-1,8.8-8.4,15.6-17.4,15.6S7.6,12,6.6,3.3L.6,1.4h0c0,12.9,10.5,23.4,23.4,23.4S47.4,14.3,47.4,1.4h0"
		/>
	</svg>
{:else}
	<svg
		width="100%"
		height="100%"
		id="Lag_1"
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		viewBox="0 0 151 26"
	>
		<defs>
			<style>
				.st0 {
					fill: #010101;
				}
			</style>
		</defs>
		<polygon
			class="st0"
			points="7.5 1.7 5.4 9.2 5.2 9.2 3.3 1.7 .8 1.7 3.7 11.4 6.8 11.4 9.7 1.7 7.5 1.7"
		/>
		<g>
			<path
				class="st0"
				d="M11.5,2c0-.9.7-1.5,1.6-1.5s1.6.6,1.6,1.5-.7,1.5-1.6,1.5-1.6-.6-1.6-1.5M12,8.5v-2.2l-2,.4v-2l4.2-.7v4.4c0,.9.4,1.3.9,1.3s1-.5,1.2-1.1l.3-1,1.9.5-.2.6c-.7,2.1-1.9,2.9-3.3,2.9s-3-.9-3-3"
			/>
			<path
				class="st0"
				d="M30.3,7.6c0-1.3-.6-1.8-1.5-1.8s-1.9.6-2.3,1c0,2.1.9,2.8,2.1,2.8s1.8-.7,1.8-2M24.2,8V1.2l2.2-.3v5h.2c.6-1.4,1.6-2,2.9-2s3,1,3,3.7-1.6,4.1-3.5,4.1-2.2-.7-2.7-2.2h-.2l-.4,2h-2.2l.6-3.4h0Z"
			/>
			<path
				class="st0"
				d="M39.6,7.1c-.2-1-.9-1.5-1.9-1.5s-1.8.5-2,1.5c0,0,3.9,0,3.9,0ZM33.4,7.7c0-2,1.2-3.9,4.2-3.9s4,1.5,4.2,4.4h-6.1c.2,1.2,1.1,1.5,2.3,1.5s1.7-.2,2.6-.9l.9,1.6c-1.1.8-2.3,1.1-3.7,1.1-3.2,0-4.4-1.8-4.4-3.8"
			/>
			<polygon
				class="st0"
				points="41.8 4 44.2 4 46.1 9.4 46.3 9.4 48.3 4 50.4 4 47.4 11.4 44.8 11.4 41.8 4"
			/>
			<path
				class="st0"
				d="M58.6,7.1c0-1.1-.2-1.7-.9-1.7s-1.1.7-1.2,1.7h2.1ZM54.5,8.6v-1.2c-.4.1-.7.3-.8.4-.5.3-.7.7-.7,1.2s.3.9.6.9c.6,0,1-.6,1-1.3M55.2,10h-.2c-.2,1-1.3,1.5-2.2,1.5s-1.9-.7-1.9-2.1c0-1.9,1.6-2.7,3.4-2.4h.1c0-1.2-.3-1.5-.9-1.5s-1.3.3-2,.9l-.9-1.3c.9-.7,2.1-1.3,3.1-1.3s1.4.3,1.9.8c.4-.5,1.1-.8,2-.8,1.9,0,2.8,1.4,2.7,4.3h-3.9c.1,1.3.6,1.9,1.5,1.9s1-.1,1.7-.7l.8,1.2c-.9.8-1.9,1.1-2.7,1.1s-2.1-.5-2.6-1.5"
			/>
			<path
				class="st0"
				d="M66.9,6.7c0-1-.7-1.4-1.5-1.4s-1.5.4-1.5,1.4.7,1.4,1.5,1.4,1.5-.4,1.5-1.4M65.7,13.5c2,0,2.1-.4,2.1-.8s-.4-.5-1.4-.5h-2c-.7,0-1.2,0-1.2.5s1.1.8,2.5.8M61.3,13.4c0-.7.3-1.3,1.7-1.4v-.2c-1.1,0-1.7-.5-1.7-1.3s.4-1.2,1.7-1.4h0c-.8-.7-1.2-1.5-1.2-2.4,0-1.7,1.2-2.9,3.7-2.9s1.3.1,1.8.4c-.1-.4-.2-.7-.2-1,0-.8.7-1.2,2-1.2s.7,0,1.2,0v1.8c-.5,0-.9-.1-1.2-.1-.6,0-1,0-1,.5,0,.6.9,1,.9,2.5s-1.2,3-3.6,3-.4,0-.6,0c-1.7-.1-2,0-2,.3,0,.4.6.4,2,.4h1.5c2.6,0,3.6.4,3.6,2s-.8,2.6-4.7,2.6-3.9-.3-3.9-1.6"
			/>
			<path
				class="st0"
				d="M76.3,7.1c-.2-1-.9-1.5-1.9-1.5s-1.8.5-2,1.5h3.9ZM70.1,7.7c0-2,1.2-3.9,4.2-3.9s4,1.5,4.2,4.4h-6.1c.2,1.2,1.1,1.5,2.3,1.5s1.7-.2,2.6-.9l.9,1.6c-1.1.8-2.3,1.1-3.7,1.1-3.2,0-4.4-1.8-4.4-3.8"
			/>
			<path
				class="st0"
				d="M81.1,6h-2.1v-1.6l4.1-.5v3.5h.2c.2-1.8,1-3,3.6-3.6l.7,2.2c-3.2.7-4.2,1.6-4.2,2.9v2.5h-2.2v-5.4h0Z"
			/>
			<path
				class="st0"
				d="M96.3,6.6l-.8-3.1h-.8l-.7,3.1h2.4ZM93.1,1.7h3.8l2.9,9.6h-2.4l-.7-2.7h-3.4l-.7,2.7h-2.2l2.6-9.6h0Z"
			/>
			<path
				class="st0"
				d="M105.5,8.2v-.7c-.4.1-1.2.4-1.7.5-.9.3-1.2.5-1.2,1s.4.6,1,.6c.9,0,1.9-.4,1.9-1.5M100.3,9.5c0-2.3,3.2-3.2,5.1-2.4h.1c0-1.1-.4-1.5-1.4-1.5s-2.3.5-3.2,1.5l-1-1.5c1.2-1.2,2.9-1.9,4.5-1.9s3.4.8,3.4,2.8v2c0,.5.2.8.8.8h.9v2h-.7c-1.6,0-2.6-.4-2.7-2.2h-.2c-.2,1.5-1.5,2.4-3.1,2.4s-2.5-.6-2.5-2"
			/>
			<path
				class="st0"
				d="M111.1,5.9h-2.1v-1.6l4.1-.5v3.5h.2c.2-1.8,1-3,3.6-3.6l.6,2.2c-3.2.7-4.2,1.6-4.2,2.9v2.5h-2.2v-5.4h0Z"
			/>
			<path
				class="st0"
				d="M118.6,1.1l2.2-.3v5.4h0c.3-1.7,1.2-2.5,2.7-2.5s2.4,1.4,2.4,3v4.6h-2.2v-4.4c0-.8-.3-1.1-1.1-1.1s-1.9.4-1.9,2.8v2.8h-2.2V1.1Z"
			/>
			<path
				class="st0"
				d="M142,10l1-1.6c1,.8,2.2,1.2,3.4,1.2s1.5-.1,1.5-.5c0-1.1-5.4.1-5.4-2.9s1.1-2.4,3.6-2.4,2.7.4,3.9,1l-.8,1.8c-1.1-.6-2.1-1-3.2-1s-1.3.2-1.3.5c0,1.1,5.4-.2,5.4,2.8s-1.7,2.5-3.8,2.5-3.2-.4-4.3-1.5"
			/>
			<path
				class="st0"
				d="M142,4.3l-1.9.6c-.3,2.8-2.7,4.9-5.5,4.9s-5.2-2.2-5.5-4.9l-1.9-.6h0c0,4.1,3.3,7.4,7.4,7.4s7.4-3.3,7.4-7.4h0Z"
			/>
			<path
				class="st0"
				d="M1.7,23.5h1.1v-2.1c.4.2.7.4,1.7,2.1h1.3c-.9-1.3-1.4-2-2-2.3l1.7-2.4h-1.3l-1.3,2.1h-.2v-2.1h-1.1v4.7ZM8.8,23.5h1v-3.6h-1.1v1.3c0,1.2-.5,1.3-.9,1.3s-.5-.2-.5-.6v-2.2h-1.1v2.3c0,.8.2,1.5,1.2,1.5s1.2-.4,1.3-1.2h0v1.1h0ZM10.7,23.5h1.1v-5.1l-1.1.2v5h0ZM14.6,23.6c.7,0,1.3-.4,1.7-1.1l-.8-.5c-.2.4-.5.7-.8.7s-.4-.2-.4-.8v-1h1.5v-.9h-1.6c.2-.3.3-.5.5-.9l-.9-.3c-.3.8-.6,1.1-.9,1.3l-.6.4.3.6.6-.3v1.2c0,1.2.5,1.6,1.4,1.6M19.4,23.5h1v-3.6h-1.1v1.3c0,1.2-.5,1.3-.9,1.3s-.5-.2-.5-.6v-2.2h-1.1v2.3c0,.8.2,1.5,1.2,1.5s1.2-.4,1.3-1.2h0v1.1h0ZM21.3,23.5h1.1v-1.1c0-.7.7-1.3,1.6-1.6l-.5-1c-.5.2-1,.9-1.1,1.8h0v-1.7h-1v3.6h0ZM28.3,23.6c1.2,0,2-.7,2-1.9s-.8-1.9-2-1.9-2,.7-2,1.9.8,1.9,2,1.9M28.3,22.7c-.6,0-.9-.4-.9-1s.3-1,.9-1,.9.4.9,1-.3,1-.9,1M32.5,25.3c1.9,0,2.4-.4,2.4-1.3s-.5-1-1.8-1h-.7c-.7,0-1,0-1-.2s.2-.2,1-.2c0,0,.2,0,.3,0,1.1,0,1.7-.6,1.7-1.4s-.5-.9-.5-1.2.2-.2.5-.2.3,0,.6,0v-.9c-.2,0-.4,0-.6,0-.7,0-1,.2-1,.6s0,.3.1.5c-.2-.1-.5-.2-.9-.2-1.2,0-1.8.6-1.8,1.4s.2.9.6,1.1h0c-.6.1-.8.4-.8.7s.3.6.8.7h0c-.7.1-.9.4-.9.8,0,.6.8.8,1.9.8M32.7,21.9c-.4,0-.8-.2-.8-.7s.3-.7.8-.7.7.2.7.7-.3.7-.8.7M31.6,24.2c0-.2.3-.2.6-.2h1c.5,0,.7,0,.7.2s-.2.4-1.2.4-1.1,0-1.1-.4M37.5,23.5h1.8c1,0,1.8-.4,1.8-1.3s-.5-1-1.1-1.1h0c.6-.1,1-.5,1-1.1,0-.9-.8-1.2-1.7-1.2h-1.8s0,4.7,0,4.7ZM39.3,22.6h-.6v-1h.6c.6,0,.8.2.8.5s-.4.5-.8.5M38.6,20.7v-1h.5c.6,0,.8.2.8.5s-.3.5-.8.5h-.5ZM43.8,23.6c1.2,0,2-.7,2-1.9s-.8-1.9-2-1.9-2,.7-2,1.9.8,1.9,2,1.9M43.8,22.7c-.6,0-.9-.4-.9-1s.3-1,.9-1,.9.4.9,1-.3,1-.9,1M46.5,23.5h1.1v-1.1c0-.7.7-1.3,1.6-1.6l-.5-1c-.5.2-1,.9-1.1,1.8h0v-1.7h-1v3.6h0ZM51.1,25.3c1.9,0,2.4-.4,2.4-1.3s-.5-1-1.8-1h-.7c-.7,0-1,0-1-.2s.2-.2,1-.2c0,0,.2,0,.3,0,1.1,0,1.7-.6,1.7-1.4s-.4-.9-.4-1.2.2-.2.5-.2.3,0,.6,0v-.9c-.2,0-.4,0-.6,0-.7,0-1,.2-1,.6s0,.3.1.5c-.2-.1-.5-.2-.9-.2-1.2,0-1.8.6-1.8,1.4s.2.9.6,1.1h0c-.6.1-.8.4-.8.7s.3.6.8.7h0c-.7.1-.9.4-.9.8,0,.6.8.8,1.9.8M51.3,21.9c-.4,0-.8-.2-.8-.7s.3-.7.8-.7.7.2.7.7-.3.7-.8.7M50.2,24.2c0-.2.3-.2.6-.2h1c.5,0,.7,0,.7.2s-.2.4-1.2.4-1.1,0-1.1-.4M55.9,23.6c.6,0,1.2-.2,1.7-.5l-.4-.8c-.4.3-.8.4-1.2.4s-.9-.2-1-.8h2.8c0-1.4-.7-2.1-1.9-2.1s-2,1-2,1.9.6,1.9,2,1.9M55,21.4c0-.5.4-.7.8-.7s.8.3.9.7h-1.7,0ZM58.4,23.5h1.1v-1.1c0-.7.7-1.3,1.6-1.6l-.5-1c-.5.2-1,.9-1.1,1.8h0v-1.7h-1v3.6h0ZM63.2,23.6c.9,0,1.7-.4,1.7-1.2,0-1.4-2.4-.9-2.4-1.4s.2-.2.5-.2c.4,0,.9.2,1.4.4l.4-.9c-.6-.3-1.1-.5-1.8-.5-1.1,0-1.6.5-1.6,1.2,0,1.5,2.4.9,2.4,1.4s-.3.3-.6.3c-.5,0-1-.2-1.4-.5l-.6.8c.5.5,1.3.7,1.9.7M67.5,23.6c.6,0,1.2-.2,1.7-.5l-.4-.8c-.4.3-.8.4-1.2.4s-.9-.2-1-.8h2.8c0-1.4-.7-2.1-1.9-2.1s-2,1-2,1.9.6,1.9,2,1.9M66.6,21.4c0-.5.4-.7.9-.7s.8.3.9.7h-1.7ZM70,23.5h1.1v-1.1c0-.7.7-1.3,1.6-1.6l-.5-1c-.5.2-1,.9-1.1,1.8h0v-1.7h-1v3.6h0ZM74.3,23.5h1.3l1.3-3.6h-1.1l-.8,2.7h0l-.8-2.7h-1.2l1.3,3.6h0ZM77.5,23.5h1.1v-3.7l-1.1.2v3.5ZM78,19.6c.4,0,.8-.3.8-.7s-.3-.7-.8-.7-.8.3-.8.7.3.7.8.7M81.2,23.6c.6,0,1.2-.2,1.7-.8l-.7-.6c-.3.4-.6.5-1,.5s-.9-.3-.9-1,.4-1,.9-1,.7.2,1,.5l.7-.6c-.4-.5-1-.8-1.8-.8-1.3,0-1.9.9-1.9,1.8s.6,1.9,2,1.9M85.3,23.6c.6,0,1.2-.2,1.7-.5l-.4-.8c-.4.3-.8.4-1.2.4s-.9-.2-1-.8h2.8c0-1.4-.7-2.1-1.9-2.1s-2,1-2,1.9.6,1.9,2,1.9M84.4,21.4c0-.5.4-.7.8-.7s.8.3.9.7h-1.7,0ZM89.5,23.5h.7l.4-1.5h1.7l.4,1.5h.7l-1.3-4.7h-1.3s-1.2,4.7-1.2,4.7ZM90.6,21.4l.5-2h.4l.5,2h-1.4ZM95,23.6c.8,0,1.5-.4,1.6-1.2h0c0,1,.4,1.1,1,1.1h0v-.6h-.2c-.3,0-.4-.1-.4-.5v-1.2c0-.9-.7-1.3-1.5-1.3s-1.5.3-2,1l.3.4c.5-.6,1.1-.8,1.7-.8s.9.3.9.9h0c-1.5-.1-2.7.3-2.7,1.3s.5,1,1.2,1M95.2,23c-.4,0-.7-.2-.7-.5s.2-.5.8-.7c.4-.1.9-.2,1.2-.3v.4c0,.7-.6,1.1-1.3,1.1M98.5,23.5h.7v-.7c0-1.2.9-2,1.7-2.3l-.3-.6c-.7.3-1.2,1-1.4,1.9h0v-1.8h-.6v3.6h0ZM101.5,23.5h.7v-1.2c0-1.3.6-1.8,1.3-1.8s.7.3.7.8v2.2h.7v-2.3c0-.8-.4-1.3-1.2-1.3s-1.3.5-1.5,1.2h0v-2.7h-.7c0,0,0,5.1,0,5.1ZM108.4,23.5h.6v-3.5h-.7v1.2c0,1.3-.6,1.8-1.3,1.8s-.7-.3-.7-.8v-2.2h-.7v2.3c0,.8.4,1.3,1.2,1.3s1.3-.5,1.5-1.3h0v1.2h0ZM111.7,23.6c1,0,1.6-.4,1.6-1.2,0-1.4-2.6-.7-2.6-1.5s.3-.5.9-.5,1,.1,1.4.4l.3-.5c-.5-.3-1-.5-1.7-.5-1,0-1.5.4-1.5,1,0,1.4,2.6.7,2.6,1.5s-.4.5-1,.5-1.1-.2-1.6-.5l-.3.5c.5.4,1.2.6,1.9.6M116,23.5h.7v-2.2c.7.2,1,.4,2.2,2.2h.8c-1-1.5-1.5-2.1-2.1-2.4l1.9-2.3h-.8l-1.7,2.2c0,0-.2,0-.3,0v-2.1h-.7v4.7h0ZM121.8,23.6c1.2,0,1.9-.7,1.9-1.8s-.7-1.8-1.9-1.8-1.9.7-1.9,1.8.7,1.8,1.9,1.8M121.8,23c-.8,0-1.2-.5-1.2-1.3s.5-1.3,1.2-1.3,1.2.5,1.2,1.3-.5,1.3-1.2,1.3M124.5,23.5h.7v-1.2c0-1.3.6-1.8,1.2-1.8s.7.3.7.8v2.2h.7v-1.2c0-1.3.5-1.8,1.2-1.8s.7.3.7.8v2.2h.7v-2.3c0-.8-.4-1.3-1.1-1.3s-1.2.5-1.3,1.2h0c0-.8-.4-1.2-1.1-1.2s-1.2.5-1.4,1.2h0v-1.2h-.6v3.6h0ZM131.2,23.5h.7v-1.2c0-1.3.6-1.8,1.2-1.8s.7.3.7.8v2.2h.7v-1.2c0-1.3.5-1.8,1.2-1.8s.7.3.7.8v2.2h.7v-2.3c0-.8-.4-1.3-1.1-1.3s-1.2.5-1.3,1.2h0c0-.8-.4-1.2-1.1-1.2s-1.2.5-1.4,1.2h0v-1.2h-.6v3.6h0ZM140.5,23.5h.6v-3.5h-.7v1.2c0,1.3-.6,1.8-1.3,1.8s-.7-.3-.7-.8v-2.2h-.7v2.3c0,.8.4,1.3,1.2,1.3s1.3-.5,1.4-1.3h0v1.2h0ZM142.1,23.5h.7v-1.2c0-1.3.6-1.8,1.3-1.8s.7.3.7.8v2.2h.7v-2.3c0-.8-.4-1.3-1.2-1.3s-1.3.5-1.5,1.2h0v-1.2h-.6v3.6h0ZM148.1,23.6c.6,0,1.1-.2,1.6-.5l-.3-.5c-.4.3-.8.4-1.2.4-.7,0-1.2-.3-1.3-1.1h3c-.1-1.6-.9-2-1.8-2s-1.9.9-1.9,1.9.6,1.8,2,1.8M146.8,21.4c.1-.6.5-1,1.1-1s1,.3,1.1,1h-2.3Z"
			/>
		</g>
	</svg>
{/if}
